import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  iconContainer: {
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  menuItem: {
    textDecoration: 'none',
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(0.5),
    backgroundColor: themeColors.secondary,
    color: themeColors.textPrimary,
    borderLeft: `3px solid ${themeColors.secondary}`,

    alignContent: 'left',
    '&:hover': {
      background: themeColors.selectedBg,
      cursor: 'pointer',
      borderLeft: `3px solid ${themeColors.selectedBg}`,
    },
    display: 'flex',
    alignItems: 'center',
  },
  activeMenuItem: {
    backgroundColor: themeColors.selectedBg,
    color: themeColors.textPrimary,
    borderLeft: `3px solid ${themeColors.selected}`,
    '&:hover': {
      background: themeColors.selectedBg,
      cursor: 'default',
    },
  },
  iconColor: {
    color: themeColors.inactive,
  },
  dropDownIcon: {
    marginLeft: 'auto',
  },
  menuItemLabel: {
    fontWeight: 600,
  },
  dropDownItemPadding:{
    paddingLeft:10
  }
}));
